import { Filter, GlProgram } from "pixi.js";
import { FILTER_VERTEX_GLSL } from "./filterVertex";

export const EXPOSURE_FRAGMENT_GLSL = `
in vec2 vTextureCoord;
out vec4 finalColor;
uniform sampler2D uTexture;
uniform float uHighlight;

void main(void) {
  vec4 o = texture(uTexture, vTextureCoord);
  // Signed exposure, hue-preserving: rgb *= 1 + highlight (premultiplied-safe —
  // alpha is untouched and black stays black, so no halo).
  o.rgb *= max(1.0 + uHighlight, 0.0);
  finalColor = o;
}
`;

/**
 * Port of `SymbolWinBrightness.effect`: one signed `highlight` uniform.
 * 0 = untouched, > 0 brightens (1 = 2×), < 0 darkens (-0.7 ≈ ×0.3).
 * Drives both the win shine and the win/label flare.
 */
export class ExposureFilter extends Filter {
  public constructor(highlight = 0) {
    super({
      glProgram: GlProgram.from({ vertex: FILTER_VERTEX_GLSL, fragment: EXPOSURE_FRAGMENT_GLSL, name: "slot-exposure", preferredFragmentPrecision: "highp" }),
      resources: {
        exposureUniforms: {
          uHighlight: { value: highlight, type: "f32" },
        },
      },
    });
  }

  public get highlight(): number {
    return this.resources.exposureUniforms.uniforms.uHighlight as number;
  }

  public set highlight(value: number) {
    this.resources.exposureUniforms.uniforms.uHighlight = value;
  }
}
